export default __webpack_public_path__ + "assets/98e8efb14b489d77cafe2ae3dc5c5a7b.jpeg";